import { render } from "./LiteExamReview.vue?vue&type=template&id=7f3f4544"
import script from "./LiteExamReview.vue?vue&type=script&lang=js"
export * from "./LiteExamReview.vue?vue&type=script&lang=js"

import exportComponent from "/builds/skilltech-ph/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__